module.exports = __webpack_public_path__ + "static/media/logo.9c0d1998.svg";